<template>
  <v-card>
    <v-card-actions>
      <div style="padding-left: 8px;">
        {{ cardTitle }}
      </div>
      <v-spacer></v-spacer>
      <!-- <v-menu bottom left v-if="isAdmin()" :disabled="isLoading"> -->
      <v-menu bottom left v-if="false" :disabled="isLoading">
        <v-btn icon slot="activator" :disabled="isLoading">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="configure()">
            <v-list-tile-title>Configurar</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="remove()">
            <v-list-tile-title class="red--text text--darken-2">Remover</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-card-actions>
    <v-card-text>
      <v-layout>
        <v-flex>
          <div v-show="isLoading" style="font-size: 28px; font-weight: 300; width: 56px; text-align: center;">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <div v-show="!isLoading" style="font-size: 28px; font-weight: 300;  width: 56px;  text-align: center;">
            <span v-show="cardInfo.cardNumber !== 0">{{ cardInfo.cardNumber }}</span>
            <v-icon v-show="cardInfo.cardNumber === 0" color="green">done</v-icon>
          </div>
        </v-flex>
        <v-flex>
          <p style="font-weight: 300; height: 42px;">{{ cardInfo.message }}</p>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-icon :color="isLoading ? 'gray' : cardInfo.lightColor">fiber_manual_record</v-icon>
      <v-spacer></v-spacer>
      <v-btn :disabled="isLoading" flat color="primary" @click="showCardDetails({})">Detalles</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import eventBus from '../../utils/eventBus'
import userStorage from '../../storage/userStorage'
export default {
  name: 'card-template',
  methods: {
    configure () {
      switch (this.cardType) {
        case 'FTP':
          // emit to: /components/dialogs/configure-ftp-dialog.vue
          eventBus.$emit('open-configure-ftp', {})
          break
        default:
          // Mark an error
      }
    },
    remove () {
      switch (this.cardType) {
        case 'FTP' :
          // open windows remove FTP
          break
        default:
          // mark an error
      }
    },
    isAdmin () {
      return userStorage.getUserInfo().userType === 'ADMIN'
    },
    showCardDetails (item) {
      // emit to: /components/dialogs/details-dialog.vue
      eventBus.$emit('open-details-dialog', {
        title: 'Titulo',
        message: 'Mensaje'
      })
    }
  },
  props: {
    cardTitle: {
      type: String,
      default () {
        return 'Sin titulo'
      }
    },
    /* cardData: {
      type: Object,
      default () {
        return {}
      }
    }, */
    isLoading: {
      type: Boolean,
      default () {
        return true
      }
    },
    cardInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    cardType: {
      type: String
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/supervisor/card-template_OLD.vue